/** @jsx h */
import { h } from 'preact';
import { useState} from 'preact/hooks';

// Props default to the add-to-cart confirmation this modal was written for.
const DraftOrderConfirmationModal = ({
  onCancel,
  onContinue,
  title = 'Add Draft Order To Cart',
  message = 'Continuing will take you to the cart which will replace any current items with this draft order.',
  pendingTitle = 'Adding Draft Order To Cart',
  pendingMessage = 'Please wait...',
  confirmLabel = 'Continue',
  destructive = false,
}) => {

  const [content, setContent] = useState({
    title,
    message,
    buttonShow: true,
  });

  const continuing = () => {
    setContent({
      title: pendingTitle,
      message: pendingMessage,
      buttonShow: false,
    });
    onContinue();
  }

  const confirmClass = destructive
    ? 'draft-confirmation-modal__button draft-confirmation-modal__button--destructive'
    : 'draft-confirmation-modal__button';

  return (
    <div className="draft-confirmation-modal">
    <div className="draft-confirmation-modal__box">
      <div className="draft-confirmation-modal__content">
        <h2 className="draft-confirmation-modal__title">
          {content.title}
        </h2>
        <p className="draft-confirmation-modal__message">
          {content.message}
        </p>
        {content.buttonShow && (
          <button
            className={confirmClass}
            onClick={continuing}
          >
            {confirmLabel}
          </button>
        )}

{content.buttonShow && (        <button className="draft-confirmation-modal__button" onClick={onCancel}>
          Cancel
        </button>)}


      </div>
    </div>
  </div>
  )
};

export default DraftOrderConfirmationModal;
